export function Loader({ label }: { label?: string }) {
  return (
    <div className="center-state">
      <div className="spinner" />
      {label && <div className="tiny">{label}</div>}
    </div>
  );
}

export function ErrorView({ message }: { message?: string }) {
  return (
    <div className="center-state">
      <div style={{ fontSize: 28 }}>♠</div>
      <div>Что-то пошло не так</div>
      {message && <div className="tiny muted">{message}</div>}
      <button
        className="btn"
        style={{ marginTop: 14 }}
        onClick={() => window.location.reload()}
      >
        Обновить
      </button>
    </div>
  );
}

export function EmptyView({ message }: { message: string }) {
  return (
    <div className="center-state">
      <div style={{ fontSize: 28, color: 'var(--text-3)' }}>♦</div>
      <div className="muted">{message}</div>
    </div>
  );
}
